import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box
} from "@mui/material";

interface ModalProps {
    open: boolean;
    handleClose: () => void;
}

const mockHistory = [
    {
        id: 1,
        dateTime: "2024-05-01 10:30 AM",
        action: "Bulk Restock",
        sku: "#PROD_001",
        change: "+50",
        prevStock: "20",
        newStock: "70",
        adminNote: "Monthly inventory refill"
    },
    {
        id: 2,
        dateTime: "2024-05-02 02:15 PM",
        action: "Sale",
        sku: "#PROD_001",
        change: "-5",
        prevStock: "70",
        newStock: "65",
        adminNote: "Order #ORD_123"
    },
    {
        id: 3,
        dateTime: "2024-05-03 11:00 AM",
        action: "Manual Override",
        sku: "#PROD_001",
        change: "-2",
        prevStock: "65",
        newStock: "63",
        adminNote: "Damaged item removed"
    },
    {
        id: 4,
        dateTime: "2024-05-04 09:45 AM",
        action: "Bulk Restock",
        sku: "#PROD_002",
        change: "+100",
        prevStock: "0",
        newStock: "100",
        adminNote: "Initial launch stock"
    }
];

export default function StockHistoryModal({ open, handleClose }: ModalProps) {
    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={handleClose}>
            <div className="modal-dialog take_action_modal" style={{ maxWidth: '900px' }}>
                <div className="modal-body">
                    {/* Header */}
                    <div className="modal_title">
                        <h2>Stock Update History</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={handleClose}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Table Content */}
                    <div className="stock_history_content mt_20">
                        <TableContainer className="table_container stock_history_table">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date & Time</TableCell>
                                        <TableCell>Action</TableCell>
                                        <TableCell>SKU</TableCell>
                                        <TableCell>Change</TableCell>
                                        <TableCell>Prev. Stock</TableCell>
                                        <TableCell>New Stock</TableCell>
                                        <TableCell>Admin Note</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {mockHistory.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell>{row.dateTime}</TableCell>
                                            <TableCell>
                                                <span className={`status_btn sm ${row.action === 'Sale' ? 'c_info' : row.action === 'Manual Override' ? 'c_warning' : 'c_success'}`}>
                                                    {row.action}
                                                </span>
                                            </TableCell>
                                            <TableCell><b>{row.sku}</b></TableCell>
                                            <TableCell>
                                                <b style={{ color: row.change.startsWith('+') ? '#2e7d32' : '#d32f2f' }}>
                                                    {row.change}
                                                </b>
                                            </TableCell>
                                            <TableCell>{row.prevStock}</TableCell>
                                            <TableCell>{row.newStock}</TableCell>
                                            <TableCell>{row.adminNote}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                    {/* Footer */}
                    <div className="footer_btn_flex mt_20">
                        <Button
                            className="btn btn_grey"
                            onClick={handleClose}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
